import LinearGradient from '@/components/basic/linear-gradient';
import theme from '@/style';
import {View} from 'react-native';
import {useInnerStyle} from '../invitation.style.hooks';
import {useTranslation} from 'react-i18next';
import {RefreshIcon} from '../svg.variables';
import Text from '@/components/basic/text';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import React, {useMemo} from 'react';
import {LazyImageBackground} from '@/components/basic/image';
import {invitationCodeCardImg, invitationColors} from '../invitation.variables';
import Button from '@/components/basic/button';
import globalStore from '@/services/global.state';
import InvitationCodeMask from './invitation-code-mask';

export interface InvitationCodeProps {
  code?: string;
  onRefreshCode?: () => void;
  onCopy?: () => void;
}

const InvitationCode: React.FC<InvitationCodeProps> = ({
  code,
  onRefreshCode,
  onCopy,
}) => {
  const {
    homeStyle,
    size: {invitationCodeCardImgHeight, invitationCodeCardImgWidth},
  } = useInnerStyle();
  const i18n = useTranslation();
  const userInfo = globalStore.userInfo;

  const renderCode = useMemo(() => {
    const finallyCode = code || '--------';
    return finallyCode.split('').map((c, i) => (
      <Text
        fontSize={theme.fontSize.xl}
        main
        blod
        key={i}
        style={[theme.font.center, theme.flex.flex1]}>
        {c}
      </Text>
    ));
  }, [code]);
  return (
    <View style={[theme.flex.col, theme.margin.btml]}>
      <View
        style={[theme.flex.row, homeStyle.codeTitle, theme.flex.centerByCol]}>
        <LinearGradient
          start={{x: 0, y: 0}}
          end={{x: 1, y: 0}}
          colors={invitationColors.codeLinear}
          style={[
            theme.fill.fillH,
            theme.flex.flex1,
            theme.flex.row,
            theme.flex.centerByCol,
            theme.padding.leftl,
          ]}>
          <Text
            color={invitationColors.codeTitle}
            blod
            fontSize={theme.fontSize.m}>
            {i18n.t('invitation.home.code-title')}
          </Text>
        </LinearGradient>
        {userInfo?.userPhone && (
          <NativeTouchableOpacity
            style={[
              theme.borderRadius.xs,
              homeStyle.resetLink,
              theme.padding.lrs,
              theme.flex.row,
              theme.flex.centerByCol,
            ]}
            onPress={onRefreshCode}>
            <RefreshIcon
              width={theme.iconSize.xs}
              height={theme.iconSize.xs}
              stroke={theme.basicColor.primary}
            />
            <Text color={theme.basicColor.primary} style={theme.margin.leftxxs}>
              {i18n.t('proxy.home.reset-link')}
            </Text>
          </NativeTouchableOpacity>
        )}
      </View>
      {/* 如果没有用户手机号, 则加上遮罩层，给出一个遮罩组件，盖在LazyImageBackground 上覆盖 */}
      <LazyImageBackground
        style={[theme.flex.row, theme.position.rel]}
        imageUrl={invitationCodeCardImg}
        width={invitationCodeCardImgWidth}
        height={invitationCodeCardImgHeight}
        occupancy="#0000">
        <View
          style={[
            homeStyle.codeCardLeft,
            theme.padding.leftl,
            theme.padding.tbxs,
            theme.padding.rights,
          ]}>
          <View
            style={[
              theme.background.white,
              theme.padding.s,
              theme.flex.centerByCol,
              theme.flex.row,
              theme.flex.flex1,
            ]}>
            {renderCode}
          </View>
        </View>
        <View style={[theme.flex.flex1, theme.flex.center]}>
          <Button
            buttonStyle={[
              theme.padding.tbxs,
              homeStyle.codeCopyBtn,
              theme.flex.center,
              {
                backgroundColor: '#9B1F42',
              },
            ]}
            onPress={onCopy}
            titleBold
            size="middle"
            title={i18n.t('label.copy')}
          />
        </View>
        <InvitationCodeMask show={!userInfo?.userPhone} />
      </LazyImageBackground>
    </View>
  );
};

export default InvitationCode;
